<template>
  <div>
    <breadcrumb/>
    <books :categories="this.categories" :category="this.categories[0]" url="/library" v-if="this.categories.length"/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BookList from "@/components/Library/BookList";
import Breadcrumb from "@/components/General/Breadcrumb";

export default {
  components: {
    Books: BookList,
    Breadcrumb
  },
  methods: {
    ...mapActions("library",["fetchCategories"])
  },
  beforeMount(){
    this.fetchCategories();

  },
  computed: {
    ...mapState("library",["categories"])
  },
  mounted(){
    // Manda el scroll al inicio cada vez que se cambia de ruta
    window.scrollTo(0, 0);
  },
};
</script>

<style>
</style>